import { render } from "./detailViewGrid.vue?vue&type=template&id=313b8437"
import script from "./detailViewGrid.vue?vue&type=script&lang=js"
export * from "./detailViewGrid.vue?vue&type=script&lang=js"

import "./detailViewGrid.vue?vue&type=style&index=0&id=313b8437&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__